import { jsx as e, jsxs as d } from "react/jsx-runtime";
import { ExternalLink as P } from "lucide-react";
import { forwardRef as W, useState as R, useRef as T, useImperativeHandle as N, useEffect as I, useCallback as y } from "react";
import { A as L } from "./Avatar-ihLwDM5D.js";
import { B as j } from "./Banner-BBfZio8n.js";
import { C as F } from "./Card-BpiP0p3P.js";
import { I as Y } from "./IconButton-D1bLZM6I.js";
import { P as k } from "./Pill-uAcQLotY.js";
import { A as U } from "./AiModeBadge-DXU_Al41.js";
import { L as O } from "./LeadTemperaturePill-CV3tceK8.js";
import { T as V } from "./Textarea-DQs10nOW.js";
const z = {
  out: {
    background: "var(--bg-elevated)",
    color: "var(--text-primary)",
    borderRadius: "var(--radius-bubble-out)",
    alignSelf: "flex-end",
    maxWidth: "78%"
  },
  in: {
    background: "var(--bg-surface)",
    color: "var(--text-primary)",
    border: "1px solid var(--border-strong)",
    borderRadius: "var(--radius-bubble-in)",
    alignSelf: "flex-start",
    maxWidth: "78%"
  },
  system: {
    background: "var(--neutral-bg)",
    color: "var(--text-secondary)",
    borderRadius: "var(--radius-pill)",
    alignSelf: "center",
    fontStyle: "italic",
    fontSize: "var(--text-xs)",
    maxWidth: "90%"
  },
  draft: {
    background: "var(--accent-dim)",
    color: "var(--text-primary)",
    border: "1px dashed var(--accent-border)",
    borderRadius: "var(--radius-bubble-out)",
    alignSelf: "flex-end",
    maxWidth: "78%"
  },
  sending: {
    background: "var(--bg-elevated)",
    color: "var(--text-secondary)",
    borderRadius: "var(--radius-bubble-out)",
    alignSelf: "flex-end",
    maxWidth: "78%",
    opacity: 0.75
  },
  sent: {
    background: "var(--success-bg)",
    color: "var(--success)",
    borderRadius: "var(--radius-bubble-out)",
    alignSelf: "flex-end",
    maxWidth: "78%",
    fontWeight: 600
  }
}, q = {
  display: "inline-block",
  padding: "var(--space-2_5) var(--space-3)",
  fontSize: "var(--text-sm)",
  lineHeight: "var(--line-sm)",
  fontFamily: "var(--font-sans)",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word"
}, _ = W(
  function({
    role: a,
    text: t,
    timestamp: o,
    detail: s,
    highlight: u = !1,
    editable: c = !1,
    initialEditValue: g,
    onEdit: b,
    editHint: m
  }, w) {
    const [l, x] = R(!1), [f, v] = R(g ?? H(t)), i = T(null), p = T(null);
    N(w, () => c ? {
      focusEditor: () => i.current?.focus()
    } : p.current, [c]), I(() => {
      if (!l) return;
      const n = i.current;
      if (!n) return;
      n.focus();
      const C = n.value.length;
      try {
        n.setSelectionRange(C, C);
      } catch {
      }
    }, [l]);
    const h = y(() => {
      c && (v(g ?? H(t)), x(!0));
    }, [c, g, t]), S = y(() => {
      x(!1);
    }, []), A = y(
      (n) => {
        h();
      },
      [h]
    ), M = y(
      (n) => {
        (n.key === "Enter" || n.key === " ") && (n.preventDefault(), h());
      },
      [h]
    ), K = y(
      (n) => {
        if (n.key === "Escape") {
          n.preventDefault(), S();
          return;
        }
        if (n.key === "Enter" && (n.metaKey || n.ctrlKey)) {
          n.preventDefault(), b?.(f), S();
          return;
        }
      },
      [f, S, b]
    ), E = {
      ...q,
      ...z[a],
      ...u ? {
        borderLeft: "3px solid var(--warning)",
        paddingLeft: "calc(var(--space-3) - 3px)"
      } : null
    }, B = {
      "data-ls-component": "message-bubble",
      "data-role": a,
      "data-editing": l || void 0,
      "data-highlight": u || void 0
    };
    return a === "system" ? /* @__PURE__ */ e(
      "li",
      {
        ref: p,
        ...B,
        style: { display: "flex", justifyContent: "center", listStyle: "none" },
        children: /* @__PURE__ */ d(
          "span",
          {
            role: "status",
            "aria-label": typeof s == "string" ? s : void 0,
            style: E,
            title: typeof s == "string" ? s : void 0,
            children: [
              "ℹ️ ",
              t
            ]
          }
        )
      }
    ) : c ? /* @__PURE__ */ d(
      "li",
      {
        ref: p,
        ...B,
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: z[a].alignSelf === "flex-end" ? "flex-end" : "flex-start",
          listStyle: "none",
          gap: "var(--space-1)"
        },
        children: [
          l ? /* @__PURE__ */ e(
            V,
            {
              ref: i,
              value: f,
              onChange: (n) => v(n.target.value),
              onKeyDown: K,
              onBlur: S,
              autoResize: !0,
              minRows: 3,
              size: "md",
              surface: "elevated",
              "data-ls-message-bubble-editor": !0,
              "aria-label": m ?? "Edit draft"
            }
          ) : /* @__PURE__ */ e(
            "button",
            {
              type: "button",
              onClick: A,
              onKeyDown: M,
              className: "ls-focus-ring",
              title: m,
              "aria-label": m,
              style: {
                ...E,
                cursor: "pointer",
                font: "inherit",
                textAlign: "left"
              },
              children: t
            }
          ),
          o ? /* @__PURE__ */ e(D, { value: o }) : null
        ]
      }
    ) : /* @__PURE__ */ d(
      "li",
      {
        ref: p,
        ...B,
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: z[a].alignSelf === "flex-end" ? "flex-end" : "flex-start",
          listStyle: "none",
          gap: "var(--space-1)"
        },
        children: [
          /* @__PURE__ */ e("span", { style: E, children: t }),
          o ? /* @__PURE__ */ e(D, { value: o }) : null
        ]
      }
    );
  }
);
_.displayName = "MessageBubble";
function D({ value: r }) {
  return /* @__PURE__ */ e(
    "span",
    {
      style: {
        fontSize: "var(--text-2xs)",
        lineHeight: "var(--line-xs)",
        color: "var(--text-tertiary)"
      },
      children: r
    }
  );
}
function H(r) {
  return typeof r == "string" ? r : typeof r == "number" ? String(r) : "";
}
const G = {
  display: "flex",
  flexDirection: "column",
  background: "var(--bg-base)",
  color: "var(--text-primary)",
  fontFamily: "var(--font-sans)",
  height: "100%",
  minHeight: 0
}, J = {
  display: "flex",
  alignItems: "center",
  gap: "var(--space-3)",
  padding: "var(--space-2_5) var(--space-4)",
  borderBottom: "1px solid var(--border-subtle)",
  background: "var(--bg-surface)",
  flex: "0 0 auto"
}, Q = W(function({
  conv: a,
  msgs: t,
  aiMode: o,
  offTargetBlocked: s = !1,
  hotOverride: u = !1,
  children: c,
  onOpenLinkedIn: g,
  onNavSettings: b,
  onActionChange: m,
  onDraftEdit: w,
  labels: l = {}
}, x) {
  const f = T(null);
  I(() => {
    const i = f.current;
    if (!i) return;
    const p = typeof window < "u" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    try {
      i.scrollTo({
        top: i.scrollHeight,
        behavior: p ? "auto" : "smooth"
      });
    } catch {
      i.scrollTop = i.scrollHeight;
    }
  }, [t]);
  const v = l.region ?? "Conversation";
  return /* @__PURE__ */ d(
    "main",
    {
      ref: x,
      "aria-label": v,
      "data-ls-component": "message-thread",
      "data-ai-mode": o,
      "data-hot-override": u || void 0,
      "data-off-target-blocked": s || void 0,
      style: G,
      children: [
        /* @__PURE__ */ e(
          X,
          {
            conv: a,
            aiMode: o,
            hotOverride: u,
            onOpenLinkedIn: g,
            labels: l,
            offTargetBlocked: s
          }
        ),
        /* @__PURE__ */ e(Z, { conv: a, labels: l }),
        a.offTarget && l.offTargetTitle ? /* @__PURE__ */ e("div", { style: { padding: "var(--space-3) var(--space-4) 0" }, children: /* @__PURE__ */ e(
          j,
          {
            tone: "warning",
            title: l.offTargetTitle,
            action: b && l.offTargetSettingsCta ? /* @__PURE__ */ e(
              "button",
              {
                type: "button",
                onClick: b,
                className: "ls-focus-ring",
                style: {
                  background: "transparent",
                  border: "none",
                  color: "var(--warning)",
                  cursor: "pointer",
                  fontWeight: 600,
                  padding: 0
                },
                children: l.offTargetSettingsCta
              }
            ) : void 0,
            children: l.offTargetBody
          }
        ) }) : null,
        /* @__PURE__ */ e(
          "div",
          {
            ref: f,
            "data-ls-region": "messages-scroll",
            style: {
              flex: "1 1 auto",
              minHeight: 0,
              overflowY: "auto",
              padding: "var(--space-4)"
            },
            children: /* @__PURE__ */ e(
              "ol",
              {
                "aria-label": l.messages ?? v,
                style: {
                  listStyle: "none",
                  margin: 0,
                  padding: 0,
                  display: "flex",
                  flexDirection: "column",
                  gap: "var(--space-3)"
                },
                children: t.map((i) => /* @__PURE__ */ e(
                  _,
                  {
                    role: i.role,
                    text: i.text,
                    detail: i.detail,
                    editable: i.role === "draft" && o === "review" && !s,
                    onEdit: w,
                    editHint: l.editDraftHint,
                    initialEditValue: typeof i.text == "string" ? i.text : void 0
                  },
                  i.id
                ))
              }
            )
          }
        ),
        a.pendingAction ? /* @__PURE__ */ e("div", { style: { padding: "0 var(--space-4) var(--space-3)" }, children: /* @__PURE__ */ e(
          $,
          {
            pendingAction: a.pendingAction,
            onActionChange: m,
            cta: l.pendingActionCta
          }
        ) }) : null,
        c ? /* @__PURE__ */ e(
          "div",
          {
            "data-ls-region": "footer",
            style: {
              flex: "0 0 auto",
              borderTop: "1px solid var(--border-subtle)",
              background: "var(--bg-surface)"
            },
            children: c
          }
        ) : null
      ]
    }
  );
});
Q.displayName = "MessageThread";
function X({
  conv: r,
  aiMode: a,
  hotOverride: t,
  onOpenLinkedIn: o,
  labels: s,
  offTargetBlocked: u
}) {
  return /* @__PURE__ */ d("header", { style: J, children: [
    /* @__PURE__ */ e(
      L,
      {
        size: "lg",
        initials: r.initials,
        tone: "neutral",
        alt: typeof r.name == "string" ? r.name : ""
      }
    ),
    /* @__PURE__ */ d(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: "var(--space-0_5)",
          flex: "1 1 auto",
          minWidth: 0
        },
        children: [
          /* @__PURE__ */ e(
            "span",
            {
              style: {
                fontSize: "var(--text-md)",
                lineHeight: "var(--line-md)",
                fontWeight: 600,
                color: "var(--text-primary)",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              },
              children: r.name
            }
          ),
          r.subtitle ? /* @__PURE__ */ e(
            "span",
            {
              style: {
                fontSize: "var(--text-2xs)",
                lineHeight: "var(--line-xs)",
                color: "var(--text-tertiary)",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              },
              children: r.subtitle
            }
          ) : null
        ]
      }
    ),
    o && r.linkedinSlug ? /* @__PURE__ */ e(
      Y,
      {
        "aria-label": s.openLinkedIn ?? "Open LinkedIn profile",
        variant: "tertiary",
        size: "sm",
        icon: /* @__PURE__ */ e(P, { "aria-hidden": !0, style: { width: 14, height: 14 } }),
        onClick: o
      }
    ) : null,
    /* @__PURE__ */ e(
      k,
      {
        tone: "neutral",
        variant: "outline",
        size: "xs",
        icon: /* @__PURE__ */ e(
          L,
          {
            size: 14,
            initials: r.account.initials,
            tone: r.account.color ? "identity" : "neutral",
            identityColor: r.account.color,
            alt: "",
            "aria-hidden": !0
          }
        ),
        children: r.account.name
      }
    ),
    /* @__PURE__ */ e(U, { mode: t ? "review" : a, children: s.aiModeLabel ?? (t ? "🔥" : a) })
  ] });
}
function Z({ conv: r, labels: a }) {
  const t = r.businesses ?? [];
  return /* @__PURE__ */ d(
    "div",
    {
      "data-ls-region": "ai-scoring-banner",
      style: {
        display: "flex",
        alignItems: "center",
        gap: "var(--space-2)",
        padding: "var(--space-2) var(--space-4)",
        borderBottom: "1px solid var(--border-subtle)",
        background: "var(--bg-surface)",
        flexWrap: "wrap"
      },
      children: [
        t.length > 0 ? t.map((o, s) => /* @__PURE__ */ e(k, { tone: "accent", variant: "soft", size: "xs", children: o }, s)) : a.scoringHorsCible ? /* @__PURE__ */ d(k, { tone: "neutral", variant: "dashed", size: "xs", children: [
          "🚫 ",
          a.scoringHorsCible
        ] }) : null,
        r.temperature ? /* @__PURE__ */ e(O, { temperature: r.temperature, size: "xs", children: r.temperature }) : null,
        r.pendingAction && a.enPauseLabel ? /* @__PURE__ */ e(k, { tone: "magenta", variant: "soft", size: "xs", uppercase: !0, children: a.enPauseLabel }) : null
      ]
    }
  );
}
function $({ pendingAction: r, onActionChange: a, cta: t }) {
  return /* @__PURE__ */ e(
    F,
    {
      padding: "md",
      radius: "xl",
      "data-ls-region": "pending-action-card",
      style: {
        background: "var(--magenta-bg)",
        borderColor: "var(--magenta-border)"
      },
      children: /* @__PURE__ */ d("div", { style: { display: "flex", flexDirection: "column", gap: "var(--space-2)" }, children: [
        /* @__PURE__ */ d("div", { style: { display: "flex", alignItems: "center", gap: "var(--space-2)" }, children: [
          r.icon ? /* @__PURE__ */ e("span", { "aria-hidden": !0, children: r.icon }) : null,
          /* @__PURE__ */ e(
            "span",
            {
              style: {
                fontWeight: 600,
                color: "var(--magenta)",
                fontSize: "var(--text-sm)"
              },
              children: r.label
            }
          )
        ] }),
        r.detail ? /* @__PURE__ */ e(
          "span",
          {
            style: {
              fontFamily: "var(--font-mono)",
              fontSize: "var(--text-xs)",
              color: "var(--text-secondary)"
            },
            children: r.detail
          }
        ) : null,
        r.reason ? /* @__PURE__ */ e("span", { style: { fontSize: "var(--text-xs)", color: "var(--text-secondary)" }, children: r.reason }) : null,
        a && t ? /* @__PURE__ */ e(
          "button",
          {
            type: "button",
            onClick: a,
            className: "ls-focus-ring",
            style: {
              alignSelf: "flex-start",
              background: "transparent",
              color: "var(--magenta)",
              border: "none",
              cursor: "pointer",
              fontWeight: 600,
              padding: 0,
              fontSize: "var(--text-xs)"
            },
            children: t
          }
        ) : null
      ] })
    }
  );
}
export {
  _ as M,
  Q as a
};
//# sourceMappingURL=MessageThread-CH1gCqwX.js.map
